export default __webpack_public_path__ + "static/media/warning--u-turn--g2.997231ed.png";